module.exports = __webpack_public_path__ + "static/media/parking.6f5299ed.svg";